import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { NotificationSilenceService } from '../../services/notification-silence.service';

interface DurationOption {
  label: string;
  durationMs: number;
}

@Component({
  selector: 'app-silence-duration',
  templateUrl: './silence-duration.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, MatIconModule]
})
export class SilenceDurationComponent {
  public readonly options: DurationOption[] = [
    { label: '30 minuten', durationMs: 30 * 60 * 1000 },
    { label: '1 uur', durationMs: 60 * 60 * 1000 },
    { label: '2 uur', durationMs: 2 * 60 * 60 * 1000 },
    { label: 'Tot morgen', durationMs: this.msUntilMidnight() },
  ];

  constructor(
    private readonly bottomSheetRef: MatBottomSheetRef<SilenceDurationComponent>,
    private readonly silenceService: NotificationSilenceService
  ) {}

  public select(option: DurationOption): void {
    this.silenceService.activate(option.durationMs);
    this.bottomSheetRef.dismiss();
  }

  private msUntilMidnight(): number {
    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime() - now.getTime();
  }
}
